import { CoreMenu } from '@core/types';

// Menu enxuto: so o que existe de verdade neste projeto.
//
// O template Vuexy vinha com ~860 linhas de itens de demonstracao (Authentication V1/V2,
// Miscellaneous, UI, Components, Forms, Tables, Charts) e com itens de e-commerce do
// proprio template que nao funcionam aqui - "Loja" sem empresa/estabelecimento na rota,
// "Lista de desejos", "Visualizar" e "Pagamento" apontando para rotas sem contexto.
// Tudo isso saiu. Esta no git se precisar consultar.
//
// Os ids fixos abaixo sao de prototipo (Durango Builder's / Dionisio Torres): o menu nao
// tem contexto de loja para passar na rota. Eles saem quando estas telas migrarem para a
// retaguarda, onde o contexto vem da sessao.
const EMPRESA = '0d1542e1-71fd-40f9-b1f7-ae00ab08626c';
const ESTABELECIMENTO = 'fe5b422e-bfb2-4328-83d4-7876020acef9';

export const menu: CoreMenu[] = [
  {
    id: 'operacao',
    type: 'section',
    title: 'Operação',
    icon: 'shopping-bag',
    children: [
      {
        id: 'aceite-pedidos',
        title: 'Aceite de pedidos',
        type: 'item',
        icon: 'check-square',
        url: `apps/e-commerce/aceite/${EMPRESA}/${ESTABELECIMENTO}`,
      },
      {
        // A loja esconde navbar, menu e rodape enquanto esta aberta, e devolve tudo ao sair.
        id: 'vitrine',
        title: 'Abrir a loja',
        type: 'item',
        icon: 'external-link',
        url: `apps/e-commerce/shop/${EMPRESA}/${ESTABELECIMENTO}`,
      },
      {
        // Area do cliente: enderecos e cartoes salvos. E tela da loja, entra aqui so
        // como atalho para testar sem passar pelo cardapio.
        id: 'area-cliente',
        title: 'Área do cliente',
        type: 'item',
        icon: 'user',
        url: `apps/e-commerce/perfil/${EMPRESA}/${ESTABELECIMENTO}`,
      },
    ],
  },
  {
    id: 'configuracao',
    type: 'section',
    title: 'Configuração',
    icon: 'settings',
    children: [
      {
        id: 'config-visual',
        title: 'Foto e capa',
        type: 'item',
        icon: 'image',
        url: `apps/e-commerce/config-visual/${EMPRESA}/${ESTABELECIMENTO}`,
      },
      {
        id: 'config-unidade',
        title: 'Unidade',
        type: 'item',
        icon: 'home',
        url: `apps/e-commerce/config-unidade/${EMPRESA}/${ESTABELECIMENTO}`,
      },
      {
        id: 'taxa-entrega',
        title: 'Taxa de entrega',
        type: 'item',
        icon: 'truck',
        url: `apps/e-commerce/config-taxa-entrega/${EMPRESA}/${ESTABELECIMENTO}`,
      },
    ],
  },
];
